module.exports = __webpack_public_path__ + "static/logo-04dee4c9e3f5ed8438f514aa2b9bf8d9.jpg";